
import _ from 'lodash';
import { useState, useEffect } from 'react';
import { _capitalize } from 'chart.js/helpers';
import { useDispatch, useSelector } from "react-redux";
import { Button, Form, Input,  Popconfirm, Select, Table, Typography } from 'antd';


import { ListingMaturityKeysThunk, ListingMaturityValueThunk } from '../../Store/Thunks/ListingMaturityThunk';
import { splitStringIntoTwoLines, stringToNumber } from '../../Helpers/ValueFormater';
import { ApiPutListingMaturityValue } from '../../Services';
import ReloadIcon from "../../Assets/img/icons/refresh.png";

const getDisplayValue = (value, record, dataIndex, isManualData) => {
  const manualValue = record[`${dataIndex}Manual`];
  return isManualData ? manualValue ?? value : value ?? manualValue;
};

const getColorStyle = (hasManualData) => ({
  color: hasManualData ? "#1890ff" : "#000",
});

const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  cellToggleState,
  handleToggleCellData,
  ...restProps
}) => {
  let inputNode;
  const options = {
    mature: { value: "mature", style: { color: '#4DC7B5' }, label: "Mature" },
    medium: { value: "medium", style: { color: 'rgb(245, 180, 82)' }, label: "Medium" },
    immature: { value: "immature", style: { color: 'rgb(242, 114, 129)' }, label: "Immature" }
  };

  if (dataIndex === 'projectMaturityParameter') {
    inputNode = (
      <Select>
        {Object.keys(options).map((key) => (
           <Select.Option key={options[key].value} value={options[key].value} style={options[key].style}>
          {options[key].label}
        </Select.Option>
        ))}
      </Select>
    );
  } else {
    inputNode = inputType === 'number' ? (
      <Input
        className="editable-field"
        formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
        parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
      />
    ) : (
      <Input
        className="editable-field"
        formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
        parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
      />
    );
  }

  const capitalize = (value) => value.charAt(0).toUpperCase() + value.slice(1);
  const renderValueWithIcon = (value, record, dataIndex) => {
    const cellKey = `${record.id}_${dataIndex}`;
    const isManualData = cellToggleState[cellKey];
    const hasManualData = record[`${dataIndex}_hasManualData`];

    let displayValue = getDisplayValue(value, record, dataIndex, isManualData);      
  
    return (
      <span style={getColorStyle(hasManualData)}>
        {displayValue}
      </span>
    );
  }

  const renderVolatilityValue = (value, record, dataIndex) => {
    const cellKey = `${record.id}_${dataIndex}`;
    const isManualData = cellToggleState[cellKey];
    const hasManualData = record[`${dataIndex}_hasManualData`];
    const isNumeric =
    typeof value === 'number' ||
    (typeof value === 'string' && /^-?\d+(\.\d+)?$/.test(value));

  if (!isNumeric) {
    return (
      <span style={getColorStyle(hasManualData)}>
        {value}
      </span>
    );
  
  } else {

     let val = record[`${dataIndex}`];
     let manualValue =  value.includes('%') ? value : `${Number(value)}%`;
     let displayValue = hasManualData ? manualValue : val.toString().startsWith("0.") ? `${Number(val*100).toFixed(2)}%`:`${Number(val).toFixed(2)}%`;
    return (
      <span style={getColorStyle(hasManualData)}>
       {displayValue}
      </span>
    );
  }
  };


  const newAdoptionRateDataFormating = (value, record, dataIndex) => {
 
    const cellKey = `${record.id}_${dataIndex}`;
    const isManualData = cellToggleState[cellKey];
    const hasManualData = record[`${dataIndex}_hasManualData`];
  const isNumeric =
    typeof value === 'number' ||
    (typeof value === 'string' && /^-?\d+(\.\d+)?$/.test(value));
  if (!isNumeric) {
    return (
      <span style={getColorStyle(hasManualData)}>
        {value}
      </span>
    );
  }
else{
    let val = record[`${dataIndex}`];
    let manualValue = value.includes('%') ? value :`${Number(value)}%`;
    let displayValue = hasManualData ? manualValue : val.toString().startsWith("0.") ? `${Number(val*100).toFixed(2)}%`:`${Number(val).toFixed(2)}%`;
    return (
      <span style={getColorStyle(hasManualData)}>
       {displayValue}
       
      </span>
    );
  }
  };  

const showAutomaticSymbol = record &&
  record[`${dataIndex}_hasManualData`] &&
  record[`${dataIndex}_automatic`]  !== null &&
  record[`${dataIndex}_automatic`] !== undefined &&
  record[`${dataIndex}_automatic`] !== 0 && 
  record[`${dataIndex}_automatic`]!== "" && 
  record[`${dataIndex}_automatic`] !== "0";
  const isNumericValue = (value) =>
  typeof value === 'number' ||
  (typeof value === 'string' && /^-?\d+(\.\d+)?$/.test(value));
const formatTransactionValue = (value) => {
  if (!isNumericValue(value)) {
    return value; 
  }

  return Number(value)
    .toFixed(0)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

  return (
    <td {...restProps}>
      {editing ? (
         <Form.Item name={[record.key, dataIndex]} style={{ margin: 0 }}>
          {inputNode}
        </Form.Item>
      ) : (
        <>
          {(dataIndex === 'projectMaturityParameter'||
           dataIndex === 'durationOfProjectsExistence' ||
           dataIndex === 'assetExistence' ||
           dataIndex === 'durationOfDevelopersFullTime' ||
           dataIndex === 'durationOfDevelopersTotal') && record[dataIndex] ? (
            capitalize(record[dataIndex])
          ) : dataIndex === 'averageNumberOfTransactionsPer7Days' && record[dataIndex] ? (
             renderValueWithIcon(
                formatTransactionValue(record[dataIndex]),
                record,
                dataIndex
              )
          ) : (dataIndex === 'numberOfAddressesWithBalance' || dataIndex === 'newAddressesPer7Days') && record[dataIndex] ? (
            record[dataIndex] !== 0 ? renderValueWithIcon(stringToNumber(record[dataIndex]), record, dataIndex) : null
          ) : (dataIndex === 'sevenDayAverage' || dataIndex === 'ninetyDayAverage') && record[dataIndex] ? (
            record[dataIndex] !== 0 ? renderValueWithIcon(`$${Number(record[dataIndex]).toLocaleString()}`, record, dataIndex) : null
          ) : dataIndex === 'newAdoptionRate' && record[dataIndex] ? (
            record[dataIndex] !== 0 ? newAdoptionRateDataFormating(`${(record[dataIndex])}`, record, dataIndex) : null
          ) : dataIndex === 'volatility' && record[dataIndex] ? (
            record[dataIndex] !== "0" ? renderVolatilityValue(`${record[dataIndex]}`, record, dataIndex) : ""
          ) : (
            children
          )}
          
             
          {showAutomaticSymbol && <span className="has_automatic" title={Number(record[`${dataIndex}_automatic`]).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}>A</span>}
          {record && record[`${dataIndex}_hasManualData`] && (
            <img
              src={ReloadIcon}
              alt="Reload"
              style={{
                width: "20px",
                position: "absolute",
                top: "50%",
                right: "10px",
                transform: "translateY(-50%)",
                cursor: "pointer"
              }}
              onClick={() => handleToggleCellData(record.id, dataIndex)}
            />
          )}
        </>
      )}
    </td>
  );
};

export default EditableCell;

export const Maturity = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isSaveClicked, setIsSaveClicked] = useState(false);
  const [editingKey, setEditingKey] = useState('');
  const [modifiedRows, setModifiedRows] = useState(new Set());
   const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [bulkEditing, setBulkEditing] = useState(false);
  const [cellToggleState, setCellToggleState] = useState({}); // Track each cell's state individually

  useEffect(() => {
    dispatch(ListingMaturityKeysThunk());
    dispatch(ListingMaturityValueThunk());
  }, []);

  const {
    ListingMaturityKeyData,
    ListingMaturityKeyLoading,
    ListingMaturityValueData,
    ListingMaturityValueLoading,
  } = useSelector((state) => state.ListingMaturityReducer);
  const isEditing = (record) => bulkEditing || record.key === editingKey;

const edit = (record) => {
  form.setFieldsValue({
    [record.key]: {
      ...record,
    },
  });

  setEditingKey(record.key);
};

  const cancel = () => {
    setEditingKey('');
  };
  const dataSource = () => {
    const arr = [];
    ListingMaturityValueData.map((item, index) => {    
      const obj = {};
      ListingMaturityKeyData.map((element) => {
        const key = element.key;
        const manualKey = `${key}Manual`;
        const cellKey = `${item.listingMaturity.id}_${key}`;
        if (item.listingMaturity) {         
            const manualDataExists = item.listingMaturity[manualKey] && item.listingMaturity[manualKey] != 0;
          obj[key] =  !manualDataExists
            ? item.listingMaturity[key]  // Automatic data
            : item.listingMaturity[manualKey]; // Manual data
    
          // Store the hasManualData flag for each cell
          obj[`${key}_hasManualData`] = manualDataExists ? true : false;
          obj[`${key}_automatic`] = item.listingMaturity[key];
          obj.id = item.listingMaturity.id;
        }
         else {     
            
          obj[element.key] = "";
          obj.id = item.id;
        }
      });
      arr.push({
        name: item.assetName,
        ...obj,
        key: index,
      });
    });
    setData(arr);
    return arr;
  };  
 
  useEffect(() => {
    if (ListingMaturityKeyData?.length && ListingMaturityValueData.length) {
      dataSource();
    }
  }, [ListingMaturityKeyData, ListingMaturityValueData, cellToggleState]);


// Handle toggle for each cell
const handleToggleCellData = async (rowId, colKey) => {
  const cellKey = `${rowId}_${colKey}`;
  setCellToggleState((prevState) => ({
    ...prevState,
    [cellKey]: !prevState[cellKey],
  }));

// Prepare data to remove manual entry
const row = data.find((item) => item.id === rowId);
if (!row) return;

const manualKey = `${colKey}Manual`;
const newItem = { id: row.id, [manualKey]: null }; // Remove manual data

   // Call API to remove manual data
   setLoading(true);
   try {
     await ApiPutListingMaturityValue([newItem]);
     setModifiedRows((prev) => {
       const newSet = new Set(prev);
       newSet.delete(cellKey); // Remove the cell from modified rows after save
       return newSet;
     });
      // Fetch updated data from the backend
      dispatch(ListingMaturityKeysThunk());
      dispatch(ListingMaturityValueThunk());
 
   } catch (error) {
     console.error("Failed to update manual data:", error);
   } finally {
     setLoading(false);
   }
};

const editAssetValue = () => {
  setLoading(true);

  const editData = [...data]
    .filter(row => Array.from(modifiedRows).some(cellId => cellId.startsWith(`${row.id}_`))) // Filter rows with modified cells
    .map(row => {
      const newItem = { id: row.id };
      Object.keys(row).forEach(colKey => {
        if (modifiedRows.has(`${row.id}_${colKey}`)) {
           if (colKey === 'sevenDayAverage'){
                 newItem[`${colKey}Manual`] = row[colKey] ? String(row[colKey]) : " ";
                }
            else if (colKey === 'ninetyDayAverage') {
                   newItem[`${colKey}Manual`] = row[colKey] ? String(row[colKey]) : "";
                  }
                   else if (colKey === 'numberOfAddressesWithBalance') {
                    newItem[`${colKey}Manual`] = row[colKey] ? String(row[colKey]) : "";
                  } else if (colKey === 'newAddressesPer7Days') {
                    newItem[`${colKey}Manual`] = row[colKey] ? String(row[colKey]) : "";
                  } 
                  else if(colKey ==="newAddressesPer7DaysManual"){
                    newItem[`${colKey}Manual`] = row[colKey] ? String(row[colKey]) : "";                                       
                  }else if (colKey === 'newAdoptionRate') {
                    newItem[`${colKey}Manual`] = row[colKey] ? String(row[colKey]) : "";
                  } else if (colKey === 'averageNumberOfTransactionsPer7Days') {
                    newItem[`${colKey}Manual`] = row[colKey] ? String(row[colKey]) : "";
                  } else if (colKey === 'volatility') {
                    newItem[`${colKey}Manual`] = row[colKey] ? String(row[colKey]) : "";
        }
        else{      
        newItem[`${colKey}`] = row[colKey];
      }
      }
    }
    );
      return newItem;
    });

  ApiPutListingMaturityValue(editData)
    .then(() => {
      setLoading(false);
      setModifiedRows(new Set());
      dispatch(ListingMaturityKeysThunk());
      dispatch(ListingMaturityValueThunk());
    })
    .catch(() => {
      setLoading(false);
    });

};
  const save = async (key) => {
  try {
    const values = await form.validateFields();

    // extract ONLY this row’s values
    const rowValues = values[key];
    if (!rowValues) return;

    setData(prevData =>
      prevData.map(row =>
        row.key === key
          ? { ...row, ...rowValues }
          : row
      )
    );

    // mark modified cells correctly
    const row = data.find(r => r.key === key);
    if (row) {
      Object.keys(rowValues).forEach(colKey => {
        if (rowValues[colKey] !== row[colKey]) {
          setModifiedRows(prev =>
            new Set(prev).add(`${row.id}_${colKey}`)
          );
        }
      });
    }

    setEditingKey('');
    setIsSaveClicked(true);
  } catch (err) {
    console.log('Validate Failed:', err);
  }
};
 
  useEffect(()=>{
    if(isSaveClicked)
    dispatch(ListingMaturityKeysThunk());
    dispatch(ListingMaturityValueThunk());
  },[isSaveClicked])

  useEffect(()=>{
    if(modifiedRows && isSaveClicked){
      editAssetValue();
    }
    setIsSaveClicked(false)
  },[modifiedRows,isSaveClicked])

  const columns = () => {
    return [
      {
        title: "#",
        dataIndex: "index",
        key: "index",
        width: 60,
        render: (text, record, index) => index + 1,
      },
      {
        title: 'Asset',
        dataIndex: 'name',
        fixed: 'left',
        width: 80,

      },
      ...ListingMaturityKeyData.map((item) => ({
        title: splitStringIntoTwoLines(item.name),
        dataIndex: item.key,
        editable: true, 
        inputType: item.key === 'projectMaturityParameter' ? 'dropdown' : 
        (item.key=='numberOfAddressesWithBalance' ||          
        item.key=='averageNumberOfTransactionsPer7Days' || 
        item.key=='sevenDayAverage' ||       
        item.key=='ninetyDayAverage' ||
        item.key=='newAddressesPer7Days') ? 'number':  'text',
        render: (text, record) => {  
          return (
            <div style={{ position: 'relative' }}> </div>
          );
        }    
      
      })),
      {
        title: 'Operation',
        dataIndex: 'operation',
        fixed: 'right',       
        render: (_, record) => {        
        
          const editable = isEditing(record);         
          return editable && !bulkEditing ? (
            <span>
              <Typography.Link
                onClick={() => save(record.key)}
                style={{ marginRight: 8 }}
              >
                Save
              </Typography.Link>
               <Popconfirm
                                title="Sure to cancel?"
                                okText="Cancel"
                                cancelText="No"
                                okButtonProps={{ style: { float: 'right' } }}
                                cancelButtonProps={{ style: { float: 'left' } }}
                                onConfirm={cancel}
                                  overlayStyle={{ paddingBottom:"20px" }}
                              >
                                <a>Cancel</a>
                       </Popconfirm>
            </span>
          ) :
           !bulkEditing ? (
            <Typography.Link disabled={editingKey !== ''} onClick={() => edit(record)}>
              Edit
            </Typography.Link>)
            :null       
        },
      },
    ];
  };

  const mergedColumns = columns().map((col) => {
    
    if (!col.editable) {
      return col;      
    }
    
    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: col.inputType,
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });


// Bulk edit
  const bulkEdit = () => {
    const values = {};
    data.forEach(row => {
      if (selectedRowKeys.includes(row.key)) values[row.key] = row;
    });
    form.setFieldsValue(values);
    setBulkEditing(true);
  };
  
const bulkSave = async () => {
  try {
    const values = await form.validateFields();
    const newData = [...data];
    const newModified = new Set(modifiedRows);

    Object.keys(values).forEach(rowKey => {
      const index = newData.findIndex(item => item.key === Number(rowKey));
      if (index > -1) {
        newData[index] = { ...newData[index], ...values[rowKey] };

        Object.keys(values[rowKey]).forEach(colKey => {
          newModified.add(`${newData[index].id}_${colKey}`);
        });
      }
    });

    setData(newData);
    setModifiedRows(newModified); // IMPORTANT
    setBulkEditing(false);
    setSelectedRowKeys([]);
setIsSaveClicked(true);
  } catch (e) {
    console.log(e);
  }
};
 
  const rowSelection = {
    selectedRowKeys,
    onChange: (keys) => setSelectedRowKeys(keys),
  };

  return (
    <div>
      <Form form={form} component={false} >
      <Table
  loading={ListingMaturityKeyLoading || ListingMaturityValueLoading || loading}
  components={{
    body: {
      cell: (props) => (
        <EditableCell
          {...props}
          cellToggleState={cellToggleState}
          handleToggleCellData={handleToggleCellData}
          
        />
      ),
    },
  }}
  style={{ width: '83vw' }}
  className="custom-scroll maturity"
  pagination={false}
  bordered
  dataSource={data}
  columns={mergedColumns}
  rowClassName="editable-row"
  scroll={{ y: 500 }}
   rowSelection={rowSelection}
/>
      </Form>
        <div style={{ marginTop: 20 }}>
        <Button disabled={!selectedRowKeys.length} onClick={bulkEdit}>Bulk Edit</Button>
        {bulkEditing && (
          <>
            <Button type="primary" style={{ marginLeft: 8 }} onClick={bulkSave}>Bulk Save</Button>
            <Button style={{ marginLeft: 8 }} onClick={() => { setBulkEditing(false); setSelectedRowKeys([]); form.resetFields(); }}>Cancel</Button>
          </>
        )}
      </div>
    </div>
  );
};
